import { list } from "@mc/mc-legacy";
import QSignDataApi from "../api/gen/qsign/QSignDataApi";
export const POZADAVEK_VYRIZENE_LIST = "pozadavekVyrizeneList";

const getRequestsByIds = (ids) => {
  return QSignDataApi.findRequestsByIds(ids);
};

const getPozadavkyAllIds = (parent, filter) => {
  return QSignDataApi.findVyrizenePozadavky();
};

export function fetchIfNeeded(forceFetch) {
  return (dispatch) => {
    dispatch(
      list.InfiniteListActions.fetchIfNeeded(
        POZADAVEK_VYRIZENE_LIST,
        null,
        getPozadavkyAllIds,
        getRequestsByIds,
        forceFetch
      )
    );
  };
}
export function loadMore() {
  return (dispatch, getState) => {
    dispatch(list.InfiniteListActions.loadMore(POZADAVEK_VYRIZENE_LIST, getRequestsByIds));
  };
}
export function invalidatePozadavky() {
  return (dispatch) => {
    dispatch(list.InfiniteListActions.invalidate(POZADAVEK_VYRIZENE_LIST));
  };
}
export function filterPozadavky(filter) {
  return (dispatch) => {
    dispatch(list.InfiniteListActions.filter(POZADAVEK_VYRIZENE_LIST, filter));
  };
}
